import React from 'react';
import { sanitizePhoneNumber } from 'lib/phoneNumbers';
import { useTranslation } from 'react-i18next';
import { Link } from '@simplybusiness/mobius';

type Props = {
  number: string,
  onClick?: () => void,
  className?: string,
};

const PhoneNumber = ({ number, onClick, className }: Props) => {
  const { t } = useTranslation();
  const phoneNumberAsLink = `tel:${sanitizePhoneNumber(number, t('international_phone_prefix'))}`;

  return <Link href={phoneNumberAsLink} onClick={onClick} className={className}>{number}</Link>;
};

export default PhoneNumber;
